var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophone1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.05176C10.3431 3.05176 9 4.3949 9 6.05176V11.0518C9 12.7086 10.3431 14.0518 12 14.0518C13.6569 14.0518 15 12.7086 15 11.0518V6.05176C15 4.3949 13.6569 3.05176 12 3.05176ZM13 19.9968V21.5518C13 22.104 12.5523 22.5518 12 22.5518C11.4477 22.5518 11 22.104 11 21.5518V19.9968C6.50005 19.4994 3 15.6843 3 11.0518C3 10.4995 3.44772 10.0518 4 10.0518C4.55228 10.0518 5 10.4995 5 11.0518C5 14.9178 8.13401 18.0518 12 18.0518C15.866 18.0518 19 14.9178 19 11.0518C19 10.4995 19.4477 10.0518 20 10.0518C20.5523 10.0518 21 10.4995 21 11.0518C21 15.6843 17.5 19.4994 13 19.9968ZM12 1.05176C14.7614 1.05176 17 3.29033 17 6.05176V11.0518C17 13.8132 14.7614 16.0518 12 16.0518C9.23858 16.0518 7 13.8132 7 11.0518V6.05176C7 3.29033 9.23858 1.05176 12 1.05176Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone1);
export default __webpack_public_path__ + "static/media/microphone 1.6e98903a4dec95c3272856bdf297a3d2.svg";
export { ForwardRef as ReactComponent };